<template>
  <div class="login_container">
    <div class="login_content">
      <div class="logo_div">
        <img :src="bosumLogo" alt="logo" />
      </div>
      <h3>登录</h3>
      <div class="login_form_div">
        <div class="inner">
          <div class="international-mobile-text" @click="internationalMobileShow = true">
            <span>+{{ countryCode }}</span>
            <img class="international-mobil-img" src="../../static/img/to-b-icon.png" />
          </div>
          <el-input v-model="myMobile" placeholder="请输入报名手机号" :maxlength="countryCode == '86' ? '11' : '15'"></el-input>
        </div>
      </div>
      <div class="login_form_div login_form_code">
        <el-input placeholder="验证码" v-model="verifyCode" class="input-with-select">
          <el-button slot="append" @click="getVerifyCode" id="verifyBtnID">{{
            appendText
            }}</el-button>
        </el-input>
      </div>
    </div>
    <div class="login_bottom">
      <button @click="loginFun">立即登记</button>
    </div>
    <div class="bottom-tip">
      <span>只有了解您，才能更好的服务您。课程有7-8个模块，现场还有咨询师，为了找到更适合您的课程和提供更针对性的咨询服务，请您花一分钟填写资料！</span>
    </div>
    <mt-popup v-model="internationalMobileShow" position="right" style="height: 100%; width: 100%">
      <div class="international-heade">
        <div class="international-title">
          <img @click="internationalMobileShow = false" src="../../static/img/go-left.png" />
          <div>选择国家和地区</div>
        </div>
        <div class="international-input">
          <el-input class="international-input-border" label="" placeholder="请输入国家名查询" v-model="queryStr">
            <el-button slot="append" icon="el-icon-search" @click="getErpCountryInfoPhoneList">搜索</el-button>
          </el-input>
        </div>
      </div>

      <div class="login-index-list">
        <mt-index-list>
          <mt-index-section v-for="(item, index1) in countryInfoPhoneList" :key="index1" :index="item.firstEn">
            <mt-cell v-for="(i, index2) in item.infoModelList" :key="index2" :title="i.nameCn + '+' + i.countryCode" @click.native="infoModelData(i.countryCode)">
            </mt-cell>
          </mt-index-section>
        </mt-index-list>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import bosumLogo from "@/assets/bosum-logo.png";
import Common from "@/utils/common";
import { getUrlParam } from "@/utils/utils";
import customerService from "@/api/customerService";
import * as VerifySDK from "@/utils/verify-sdk/index.js";


export default {
  name: "login",
  data: function () {
    return {
      bosumLogo,
      activityId: "",
      myMobile: "",
      verifyCode: "",
      appendText: "点击获取验证码",
      countTimer: null,
      isDisabled: false, //拦截重复发送验证码
      countryInfoPhoneList: [],
      countryCode: "86",
      internationalMobileShow: false,
      queryStr: "",
    };
  },
  mounted() {
    var vm = this;
    vm.activityId = getUrlParam("activityId");
    console.log(vm.activityId);
    vm.getErpCountryInfoPhoneList();

    VerifySDK.init().then(successData => {
      console.log("接收成功信息:", successData);
      // 这里可以使用 successData（即 SDK 实例）进行后续操作
      vm.verifySEvent()
    }).catch(error => {
      console.error("处理错误:", error);
    });
  },
  methods: {
    getErpCountryInfoPhoneList() {
      var vm = this;
      customerService.getErpCountryInfoPhoneList(this).then(function (data) {
        for (var i = 0; i < data.length; i++) {
          if (data[i].firstEn === "hot") {
            var obj = data.splice(i, 1);
            obj[0].firstEn = "热门";
            break;
          }
        }
        data.unshift(obj[0]);
        vm.countryInfoPhoneList = data;
        // for (var i = 0; i < data.pageData.length; i++) {
        //   if (data.pageData[i].firstEn === "hot") {
        //     var obj = data.pageData.splice(i, 1);
        //     obj[0].firstEn = "热门";
        //     break;
        //   }
        // }
        // data.pageData.unshift(obj[0]);
        // vm.countryInfoPhoneList = data.pageData;
      });
    },
    infoModelData(val) {
      this.countryCode = val;
      this.internationalMobileShow = false;
    },
    loginFun: function () {
      var vm = this;
      if (Common.Util.isEmpty(vm.myMobile)) {
        Common.PageOperator.showPromptMsg(
          vm,
          true,
          "请填写手机号码",
          "warning"
        );
        return;
      }
      if (!Common.Util.isMobileCode(vm.countryCode, vm.myMobile)) {
        Common.PageOperator.showPromptMsg(
          vm,
          true,
          "请输入正确的手机号",
          "warning"
        );
        return;
      }
      // if (!Common.Util.isMobile(vm.myMobile)) {
      //   Common.PageOperator.showPromptMsg(vm, true, '手机号码格式错误，请重新填写', 'warning');
      //   return;
      // }
      if (Common.Util.isEmpty(vm.verifyCode)) {
        Common.PageOperator.showPromptMsg(vm, true, "请输入验证码", "warning");
        return;
      }
      customerService
        .getInformationVOByVerifyCode(
          vm,
          vm.activityId,
          vm.myMobile,
          vm.verifyCode,
          vm.countryCode
        )
        .then(function (data) {
          vm.$eventBus.$emit("userInfo", data);
          vm.$router.push({
            path: "/profile",
            query: { activityId: vm.activityId, mobile: data.userMobile, areaCode: vm.countryCode },
          });
        });
    },
    getVerifyCode: function () {
      // var vm = this;
      // if (vm.isDisabled) {
      //   return;
      // }
      // vm.isDisabled = true;
      // if (Common.Util.isEmpty(vm.myMobile)) {
      //   Common.PageOperator.showPromptMsg(
      //     vm,
      //     true,
      //     "请填写手机号码",
      //     "warning"
      //   );
      //   return;
      // }
      // // if (!Common.Util.isMobile(vm.myMobile)) {
      // //   Common.PageOperator.showPromptMsg(vm, true, '手机号码格式错误，请重新填写', 'warning');
      // //   return;
      // // }
      // customerService.sendMobileVerifyCode(vm, vm.myMobile,vm.countryCode).then(
      //   function (data) {
      //     vm.countDownFun();
      //   },
      //   function (error) {
      //     vm.hasSend = "重新发送";
      //     vm.isDisabled = false;
      //   }
      // );
    },
    countDownFun: function () {
      var vm = this;
      vm.appendText = 60;
      vm.countTimer = setInterval(function () {
        if (vm.appendText <= 0) {
          vm.appendText = "重新发送";
          vm.isDisabled = false;
          clearInterval(vm.countTimer);
        } else {
          vm.appendText--;
        }
      }, 1000);
    },
    sendSmsCode(captchaVerification) {
      var vm = this;
      if (vm.isDisabled) {
        return;
      }
      vm.isDisabled = true;
      if (Common.Util.isEmpty(vm.myMobile)) {
        Common.PageOperator.showPromptMsg(
          vm,
          true,
          "请填写手机号码",
          "warning"
        );
        return;
      }
      // customerService.sendMobileVerifyCode(vm, vm.myMobile, vm.countryCode).then(
      //   function (data) {
      //     vm.countDownFun();
      //   },
      //   function (error) {
      //     vm.hasSend = "重新发送";
      //     vm.isDisabled = false;
      //   }
      // );

      console.log('"匹配成功"');
      var vm = this;
      let data = {
        "phoneNumber": vm.myMobile,
        "areaCode": vm.countryCode,
        "captchaVerification": captchaVerification
      }
      VerifySDK.postSmsSendEvent(data).then((res) => {
        console.log('发送', res)

        if (res && res.code == 2000) {
          // Notify({ type: "success", message: res.data || "短信已发送" });
          vm.$message.success(res.data || "短信已发送");
          vm.countDownFun();
        } else {
          vm.hasSend = "重新发送";
          vm.isDisabled = false;

          Common.PageOperator.showPromptMsg(
            vm,
            true,
            res.error ||res.errorMessage|| "获取失败,请重试!",
            "warning"
          );
        }
      }).catch(function (error) {
        vm.hasSend = "重新发送";
        vm.isDisabled = false;
        // Notify({ type: "danger", message: error.message || "获取失败,请重试!" });
        Common.PageOperator.showPromptMsg(
          vm,
          true,
          res.message || res.error ||res.errorMessage||"获取失败,请重试!",
          "warning"
        );
      });

    },
    verifySEvent() {
      let vm = this;
      let option = {
        // baseUrl: 'https://captcha.anji-plus.com/captcha-api',  //服务器请求地址, 默认地址为安吉服务器;
        // baseUrl: 'https://erptest.bosum.com/erp/message',  //服务器请求地址, 默认地址为安吉服务器;
        // baseUrl: 'https://aitenanttest.bosum.com/aibs/manager/system',  //服务器请求地址, 默认地址为安吉服务器;

        mode: 'pop',     //展示模式
        containerId: 'verifyBtnID',//pop模式 必填 被点击之后出现行为验证码的元素id
        // imgSize: {       //图片的大小对象,有默认值{ width: '310px',height: '155px'},可省略
        //   width: '460px',
        //   height: '200px',
        // },
        imgSize: {       //图片的大小对象,有默认值{ width: '310px',height: '155px'},可省略
          width: '300px',
          height: '140px',
        },
        barSize: {          //下方滑块的大小对象,有默认值{ width: '310px',height: '50px'},可省略
          width: '300px',
          height: '30px',
        },

        beforeCheck: function () {  //检验参数合法性的函数  mode ="pop"有效
          if (Common.Util.isEmpty(vm.myMobile) || Common.Util.isEmpty(vm.countryCode)) {
            // alert("请完胜输入信息。")
            // vm.$message.warning("请输入手机号码和国家代码。")
            Common.PageOperator.showPromptMsg(
              vm,
              true,
              "请填写手机号码",
              "warning"
            );
            window.console.error('请输入手机号码和国家代码。',)
            return false
          } else {
            return true
          }

        },
        ready: function (ready) {
        },  //加载完毕的回调
        success: function (params) { //成功的回调
          vm.sendSmsCode(params.captchaVerification)
        },
        error: function (err) {
          console.log('error222222222222', err)
        }        //失败的回调
      }
      VerifySDK.initSlideVerify(option)
    },
  },

  beforeDestroy() {
    var vm = this;
    vm.countTimer && clearInterval(vm.countTimer);
    VerifySDK.destroySlideVerify();
  },
};
</script>

<style scoped>
.login_container {
  padding: 50px 30px 0;
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.bottom-tip {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  color: #999;
  padding: 0 30px 15px;
}

.login_content {}

.login_content>h3 {
  letter-spacing: 1px;
  font-size: 24px;
  margin-bottom: 30px;
  font-weight: normal;
  color: #000;
}

.login_content>p {
  font-size: 18px;
  margin-bottom: 20px;
}

.logo_div {
  margin-bottom: 10px;
}

.logo_div>img {
  width: 160px;
}

.login_form_div {
  width: 100%;
  height: 50px;
  background: #ffffff;
  box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.06);
}

.login_form_code {
  padding-right: 10px;
}

.login_form_div>.inner {
  border-bottom: 1px solid #eee;
  margin: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.login_form_div>.inner>span {
  border-right: 1px solid #eee;
  width: 50px;
  display: inline-block;
  text-align: center;
  height: 28px;
  line-height: 28px;
}

.login_bottom {
  width: 100%;
  margin-top: 50px;
}

.login_bottom>button {
  width: 100%;
  height: 46px;
  background: #d43d3d;
  color: #fff;
  font-size: 18px;
  box-shadow: 0px 5px 6px 0px rgba(212, 61, 61, 0.6);
  border: none;
  border-radius: 3px;
}

/deep/.international-mobile>.el-form-item__content {
  display: flex;
  justify-content: space-between;
}

.mint-indexsection-index {
  font-weight: 800;
}

.stem-weight {
  font-weight: 800;
}

.international-mobile-text {
  color: #666;
  font-size: 15px;
  width: 80px;
}

.international-mobil-img {
  width: 11px;
  height: 7px;
}

.international-heade {
  padding: 10px 15px;
  position: fixed;
  width: 100%;
  height: 110px;
}

.international-title {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-size: 18px;
  font-weight: 800;
}

.international-title>img {
  width: 23px;
  position: absolute;
  left: 0;
}

.international-input-border {
  margin-right: 20px;
  margin-top: 10px;
  border-radius: 10px;
}

.login-index-list {
  margin-top: 110px;
  margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue